import { IEquityMovementScheduleTableEntryFlis } from './equity-movement-schedule-table-entry-flis.interface';

export interface IEquityMovementSchedulePrintPreviewTableRow {
    movementName: string | null;
    flis: IEquityMovementScheduleTableEntryFlis;
    rowTotal: number | null;
}
